import React from "react";
import { Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import BoxingTableContextMenu from "../ContextMenuItems/BoxingTableContextMenu";
import { HubHookFormInput } from "../../../components";

import { StyledCell, StyledWorkOrderStack } from "../styles";
import WorkOrderSelectField from "../WorkOrderSelectField";

const WorkOrderTableRow = ({
  idx,
  item,
  remove = () => {},
  disabled,
  options = [],
}) => {
  const prefix = `workOrders.${idx}`;

  const { getValues, setValue, watch } = useFormContext();

  const onDelete = () => remove(idx);

  const handleWorkOrderChange = () => {
    const workOrderId = getValues(`${prefix}.workOrderId`);
    const workOrder = options?.find((wo) => wo.id === workOrderId);
    const quantity = workOrder.available;
    setValue(`${prefix}.quantity`, quantity, { shouldValidate: true });
  };

  const workOrderId = watch(`${prefix}.workOrderId`);
  const workOrder = options?.find(({ id }) => workOrderId === id);
  const qty = workOrder?.quantity || 0;
  const endAdornment = qty ? `/${qty}` : "";

  const partNumber = workOrder?.part?.partNumber;
  const partName = workOrder?.part?.partName;

  return (
    <StyledWorkOrderStack>
      <WorkOrderSelectField
        name={`${prefix}.workOrderId`}
        defaultValue={item?.workOrderId}
        onChange={handleWorkOrderChange}
        options={options}
        disabled={disabled}
        required
      />
      <StyledCell sx={{ paddingLeft: "10px" }}>
        <Typography variant="caption11">{partNumber}</Typography>
      </StyledCell>
      <StyledCell sx={{ paddingLeft: "10px" }}>
        <Typography variant="caption11">{partName}</Typography>
      </StyledCell>
      <HubHookFormInput
        name={`${prefix}.quantity`}
        defaultValue={item?.quantity}
        disabled={disabled}
        placeholder="# of parts"
        endAdornment={endAdornment}
        required
        isNumber
      />
      <StyledCell>
        <BoxingTableContextMenu
          idx={idx}
          serialName={`${prefix}.serialization`}
          onDelete={onDelete}
          hideSplit
        />
      </StyledCell>
    </StyledWorkOrderStack>
  );
};

export default WorkOrderTableRow;
